import { FC } from 'react';

import CheckboxGroup from '@/components/ui/CheckboxGroup';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const WHAT_WAS_REPAIRED_OPTIONS = {
  DRYING: 'drying',
  MOLD_REMOVAL: 'mold_removal',
  OZONATION: 'ozonation',
  ELECTRICAL_INSTALLATION_CHECK: 'electrical_installation_check',
  NONE_OF_THE_ABOVE: 'none_of_the_above',
} as const;

export const WHAT_WAS_REPAIRED_NAME = 'what_was_repaired';

interface Props {
  name?: string;
}

export const CheckboxGroupWhatWasRepaired: FC<Props> = ({
  name = WHAT_WAS_REPAIRED_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <div id={name} className="overflow-initial scroll-mt-10">
      <FormField
        control={control}
        name={name}
        rules={{
          required: {
            value: true,
            message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
          },
        }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {i18n.t('Co zostało wykonane w ramach naprawy?')}
            </FormLabel>
            <FormControl>
              <CheckboxGroup
                field={field}
                data-testid={`${name}-checkbox-group`}
                options={[
                  {
                    value: WHAT_WAS_REPAIRED_OPTIONS.DRYING,
                    label: i18n.t('Osuszanie'),
                  },
                  {
                    value: WHAT_WAS_REPAIRED_OPTIONS.MOLD_REMOVAL,
                    label: i18n.t('Odgrzybianie'),
                  },
                  {
                    value: WHAT_WAS_REPAIRED_OPTIONS.OZONATION,
                    label: i18n.t('Ozonowanie'),
                  },
                  {
                    value:
                      WHAT_WAS_REPAIRED_OPTIONS.ELECTRICAL_INSTALLATION_CHECK,
                    label: i18n.t('Sprawdzenie instalacji elektrycznej'),
                  },
                  {
                    value: WHAT_WAS_REPAIRED_OPTIONS.NONE_OF_THE_ABOVE,
                    label: i18n.t('Żadne z powyższych'),
                    willResetRest: true,
                  },
                ]}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
